import { instance as axios } from "@/store/_AXIOS"
import { _TOKEN, _DECODE } from "@/store/_JWT"

const TABLE = "/comprovativo/"

// initial state
const state = {
  data: []
}

// getters
const getters = {}

// actions
const actions = {
  ComprovativoDonativo({ dispatch }, params) {
    return axios
      .post(TABLE + "donativo/", {
        t: _TOKEN(params)
      })
      .then(res => {
        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

  ComprovativoCota({ dispatch }, params) {
    return axios
      .post(TABLE + "cota/", {
        t: _TOKEN(params)
      })
      .then(res => {
        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  }
}

// mutations
const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
